import GiftDescriptionProvider from './hooks/useGiftDescription';

import { GiftDescriptionProps } from './@types/GiftDescriptionProps';

const GiftDescription = (props: GiftDescriptionProps) => (
	<GiftDescriptionProvider {...props}>
		<span
			data-selection={`${props.componentId}`}
			className="vtex-product-gifts-0-x-giftDescription giftDescription t-small c-muted-1"
		>
			Camiseta Overside confortável e super estilosa para o dia a dia
		</span>
	</GiftDescriptionProvider>
);

export default GiftDescription;
